module.exports = __webpack_public_path__ + "a402879a1716dc86271e2ab903445d34.png";